import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Template } from "@/lib/types";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CreateFromTemplatePreviewAndConfigDialogStaticTab } from "./CreateFromTemplatePreviewAndConfigDialogStaticTab";
import { CreateFromTemplatePreviewAndConfigDialogDynamicTab } from "./CreateFromTemplatePreviewAndConfigDialogDynamicTab";

interface Props {
  template: Template;
  onClose: () => void;
  onUploadSuccess: () => void;
}

export const CreateFromTemplatePreviewAndConfigDialog: React.FC<Props> = ({ template, onClose, onUploadSuccess }) => {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[80vw] max-w-[95vw] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {t("content.createFromTemplate")}:{" "}
            <span className="underline">
              {template.name} ({template.viewport_size})
            </span>
          </DialogTitle>
        </DialogHeader>
        <Tabs defaultValue="static">
          <TabsList>
            <TabsTrigger value="static">{t("Static")}</TabsTrigger>
            <TabsTrigger value="dynamic">{t("Dynamic")}</TabsTrigger>
          </TabsList>
          <TabsContent value="static">
            <CreateFromTemplatePreviewAndConfigDialogStaticTab
              template={template}
              onClose={onClose}
              onUploadSuccess={onUploadSuccess}
            />
          </TabsContent>
          <TabsContent value="dynamic">
            <CreateFromTemplatePreviewAndConfigDialogDynamicTab
              template={template}
              onClose={onClose}
              onUploadSuccess={onUploadSuccess}
            />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
